import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class NotificheService {
  private resourceUrl = environment.apiUrl + 'notification';

  constructor(private http: HttpClient) { }

  getAllNotifiche(): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/created');
  }
  getType(): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/type');
  }
  getNotifiche(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/header');
  }
  create(request): Observable<any[]> {
    return this.http.post<any[]>( this.resourceUrl , request);
  }
  save(request: any, id: number): Observable<any[]> {
    return this.http.post<any[]>( this.resourceUrl + '/' + id, request);
  }
  getNotificheBase(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id);
  }
  getNotification(): Observable<any> {
    return this.http.get<any>(this.resourceUrl);
  }
  getNotificheSubscribers(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/readers');
  }
  publishNotifica(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/publish');
  }
  getSearchItem(id:number, str: string): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/search_structure/' + str);
  }
  delNotifica(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id);
  }
  deleteAttachment(id: number, fileType: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id + '/file/' + fileType);
  }
  loadAttachment(file: File, fileType: number, idNotifica: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/' + idNotifica + '/file/', formData, {observe: 'response'});
  }
}



// WEBPACK FOOTER //
// ./src/app/notifiche/notifiche.service.ts